import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
// import { v4 as uuidv4 } from "uuid";

import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import ForwardModal from "../../components/ForwardMessageModal";
import ShowTicketOpen from "../ShowTicketOpenModal";
import AcceptTicketWithoutQueue from "../AcceptTicketWithoutQueueModal";

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  menuPosition,
  isGroup,
  queueId,
  whatsappId,
  channel
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const editingContext = useContext(EditMessageContext);
  const setEditingMessage = editingContext ? editingContext.setEditingMessage : null;
  const { setTabOpen } = useContext(TicketsContext);
  const history = useHistory();

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);

  const [ticketOpen, setTicketOpen] = useState(null);

  const { showSelectMessageCheckbox,
    setShowSelectMessageCheckbox,
    selectedMessages,
    setSelectedMessages,
    forwardMessageModalOpen,
    setForwardMessageModalOpen } = useContext(ForwardMessageContext);

  const handleSaveTicket = async (contactId) => {
    if (!contactId) return;

    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: contactId,
        userId: user?.id,
        status: "open",
        queueId: queueId,
        whatsappId: whatsappId
      });

      setTicketOpen(ticket);
      if (ticket.reusedOpenTicket) {
        toast.info(i18n.t("showTicketOpenModal.reusedTicketToast"));
      }
      if (ticket.queueId === null) {
        setAcceptTicketWithouSelectQueueOpen(true);
      } else {
        setTabOpen("open");
        history.push(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      const status = err.response?.status;
      const data = err.response?.data;

      if (status === 403 && data?.ticket) {
        setOpenAlert(true);
        setUserTicketOpen(data.ticket?.user?.name || "");
        setQueueTicketOpen(data.ticket?.queue?.name || "");
        handleClose();
        return;
      }

      if (status === 409 && data?.error) {
        try {
          const ticket = typeof data.error === "string" ? JSON.parse(data.error) : data.error;
          if (ticket.userId !== user?.id) {
            setOpenAlert(true);
            setUserTicketOpen(ticket.user?.name);
            setQueueTicketOpen(ticket.queue?.name);
          } else {
            setOpenAlert(false);
            setUserTicketOpen("");
            setQueueTicketOpen("");
            setTabOpen(ticket.status);
            history.push(`/tickets/${ticket.uuid}`);
          }
        } catch (_) {
          toastError(err);
        }
        handleClose();
        return;
      }

      toastError(err);
    }
    //setLoading(false);
    handleClose();
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
  };

  const handleSetShowSelectCheckbox = () => {
    // FIX 14/06: ao ATIVAR modo selecao, pre-seleciona a msg clicada.
    // UX: usuario clica "Encaminhar" no menu -> msg ja entra selecionada.
    if (!showSelectMessageCheckbox) {
      const list = selectedMessages || [];
      if (!list.some((m) => m.id === message.id)) {
        list.push(message);
        setSelectedMessages([...list]);
      }
    } else {
      // Saindo do modo - limpar selecao
      setSelectedMessages([]);
    }
    setShowSelectMessageCheckbox(!showSelectMessageCheckbox);
    handleClose();
  };

  const isOfficialApi = channel === "whatsapp_oficial";

  const handleDeleteMessage = async () => {
    if (isOfficialApi) {
      toast.warn(i18n.t("messageOptionsMenu.officialApiNoEditDelete"));
      setConfirmationOpen(false);
      return;
    }
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleEditMessage = () => {
    if (isOfficialApi) {
      toast.warn(i18n.t("messageOptionsMenu.officialApiNoEditDelete"));
      handleClose();
      return;
    }
    setEditingMessage(message);
    handleClose();
  };
  // const handleForwardMessage = (msg) => {
  //   setForwardModalOpen(true);
  //   setForwardMessage(msg);
  //   handleClose();
  // };
  // const handleCloseForwardModal = () => {

  //   //setSelectedSchedule(null);
  //   setForwardModalOpen(false);
  //   handleClose();
  // };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const isWithinFifteenMinutes = () => {
    const fifteenMinutesInMilliseconds = 15 * 60 * 1000; // 15 minutos em milissegundos
    const currentTime = new Date();
    const messageTime = new Date(message.createdAt);

    // Verifica se a diferença entre o tempo atual e o tempo da mensagem é menor que 15 minutos
    return currentTime - messageTime <= fifteenMinutesInMilliseconds;
  };

  /** Só mensagem de texto (como no WhatsApp): sem mídia/arquivo anexo. */
  const isPlainTextMessage = () => {
    const url = message.mediaUrl && String(message.mediaUrl).trim();
    if (url) return false;
    const mt = (message.mediaType && String(message.mediaType).toLowerCase()) || "";
    // conversation / extendedTextMessage: Baileys; "text": SendWuzAPIMessage (Meow/WuzAPI)
    if (!mt || mt === "conversation" || mt === "extendedtextmessage" || mt === "text") return true;
    return false;
  };

  const handleOpenConfirmationModal = (e) => {
    if (isOfficialApi) {
      toast.warn(i18n.t("messageOptionsMenu.officialApiNoEditDelete"));
      handleClose();
      return;
    }
    setConfirmationOpen(true);
    handleClose();
  };

  return (
    <>
      <AcceptTicketWithoutQueue
        modalOpen={acceptTicketWithouSelectQueueOpen}
        onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
        ticket={ticketOpen}
        ticketId={ticketOpen?.id}
      />
      <ShowTicketOpen
        isOpen={openAlert}
        handleClose={handleCloseAlert}
        user={userTicketOpen}
        queue={queueTicketOpen}
      />
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>

      <ForwardModal
        modalOpen={forwardMessageModalOpen}
        messages={selectedMessages}
        onClose={(e) => {
          setForwardMessageModalOpen(false);
          setShowSelectMessageCheckbox(false);
        }}
      />
      <Menu
        anchorEl={menuPosition ? null : anchorEl}
        anchorReference={menuPosition ? "anchorPosition" : "anchorEl"}
        anchorPosition={menuPosition || undefined}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message.fromMe && (
          <MenuItem key="delete" onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        {message.fromMe && isWithinFifteenMinutes() && isPlainTextMessage() && (
          <MenuItem key="edit" onClick={handleEditMessage}>
            {i18n.t("messageOptionsMenu.edit")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        <MenuItem onClick={handleSetShowSelectCheckbox}>
          {i18n.t("messageOptionsMenu.forward")}
        </MenuItem>
        {!message.fromMe &&
          isGroup &&
          message?.contact?.id &&
          !message?.contact?.isGroup && (
          <MenuItem onClick={() => handleSaveTicket(message?.contact?.id)}>
            {i18n.t("messageOptionsMenu.talkTo")}
          </MenuItem>
        )}
        {((message.mediaType || "").toLowerCase().includes("sticker") || (message.body === "sticker" && message.mediaUrl)) && (
          <MenuItem onClick={async () => {
            try {
              await api.post("/stickers/favorite", { messageId: message.id });
              toast.success("Figurinha adicionada aos favoritos!");
            } catch (err) {
              toastError(err);
            }
            handleClose();
          }}>
            Favoritar figurinha
          </MenuItem>
        )}
      </Menu>
    </>

  );
};

export default MessageOptionsMenu;